/**
 * Checks whether the code is running on the client (browser) side.
 * @returns boolean
 */
export const isClientSideUtil = () => typeof window !== "undefined";
export default isClientSideUtil;
